import { useContext, useEffect, useState } from 'react'
import { Loader } from '@nv/basic-components'
import { ModalContext } from '@nv/contexts'
import { AdminVoterService } from '@nv/services'
import { useTranslation } from 'react-i18next'
import StyledReactSelect from './custom_dropdown/StyledReactSelect'
import styles from './UserAdvancedFilters.module.scss'

const USER_TYPES = ['REG', 'RAND', 'RTIR', 'CANC', 'TEST']

export const UserAdvancedFilters = ({ appliedFilters, setAppliedFilters, userFilterTypes, showMemberTypeFilter = false }) => {
  const { t } = useTranslation()
  const { i18n } = useTranslation()
  const currentLanguage = i18n.language
  const [options, setOptions] = useState(null)
  const [loading, setLoading] = useState(true)
  const [filters, setFilters] = useState(appliedFilters)
  const { setHeaderLabel, setBtns, onClose } = useContext(ModalContext)

  const getParentFilters = async () => {
    const optionsUserType = USER_TYPES.map((u) => ({
      label: u,
      value: u,
      accountId: u,
    }))
    let localOptions = { userType: optionsUserType }
    for (let i = 0; i < userFilterTypes.length; i++) {
      if (i % 2 === 0) {
        const optionsFilter = await AdminVoterService.getParentFilters(userFilterTypes[i], currentLanguage)
        localOptions = { ...localOptions, [userFilterTypes[i]]: optionsFilter || [] }
      }
    }
    setOptions(localOptions)
    setLoading(false)
  }

  const getChildFilters = async (filters, filterType, parentFilterIndex) => {
    const groupedChildFilters = []
    for (const filter of filters) {
      const childFilters = await AdminVoterService.getChildFilters(filter.accountId, currentLanguage)
      groupedChildFilters.push({
        label: filter.title[currentLanguage],
        options: childFilters,
      })
    }
    setOptions({ ...options, [userFilterTypes[parentFilterIndex + 1]]: groupedChildFilters })
  }

  const onSelectFilter = (filter, action, filterType) => {
    setFilters({ ...filters, [`accountId${filterType}`]: filter })
    const filterIndex = userFilterTypes.findIndex((f) => f === filterType)
    if (filterIndex % 2 === 0) {
      getChildFilters(filter, filterType, filterIndex)
      // Reset selected children if clear all parent filters or remove one parent filter
      if ((action.action === 'clear' || action.action === 'remove-value') && filterIndex < userFilterTypes.length - 1) {
        setFilters({
          ...filters,
          [`accountId${userFilterTypes[filterIndex + 1]}`]: [],
          [`accountId${filterType}`]: filter,
        })
      }
    }
  }

  const onSelectUserType = (filter) => setFilters({ ...filters, userType: filter })

  const onCancel = () => {
    setFilters({})
    getParentFilters()
    onClose()
  }

  const onApplyFilters = () => {
    setAppliedFilters(filters)
    onClose()
  }

  useEffect(() => {
    getParentFilters()
  }, [currentLanguage])

  useEffect(() => {
    setHeaderLabel(t('filters.filterBy'))
    setBtns([
      { text: t('buttons.cancel'), onClick: onCancel, variant: 'secondary' },
      { text: t('buttons.apply'), onClick: onApplyFilters },
    ])
  }, [filters])

  return (
    <>
      {loading ? (
        <Loader />
      ) : (
        <div className={styles['container']}>
          {userFilterTypes.map((filterType, i) => (
            <div key={i} className={styles['dropdown__container']}>
              <StyledReactSelect
                options={options[filterType] || []}
                styles={{}}
                label={t(`filters.userFilters.${filterType.toLowerCase()}`)}
                onChange={(e, action) => onSelectFilter(e, action, filterType)}
                value={filters[`accountId${filterType}`] || []}
                isClearable
                isMulti
                placeholder={t('form.select.select')}
              />
            </div>
          ))}
          {showMemberTypeFilter && (
            <div className={styles['dropdown__container']}>
              <StyledReactSelect
                options={options?.userType || []}
                styles={{}}
                label={t('filters.userFilters.userType')}
                onChange={(e) => onSelectUserType(e)}
                value={filters.userType || []}
                isClearable
                isMulti
                placeholder={t('form.select.select')}
              />
            </div>
          )}
        </div>
      )}
    </>
  )
}
